import {observable, computed, toJS, action} from 'mobx';
import moment from 'moment';
import {getIn} from '../utils';
import createSelector, {LruCacheObject} from 're-reselect';

import {TIME_UNIT_ID} from '../model/const';

window.moment = moment

class UPDTSlot {
  @observable content = {};

  constructor(content, available) {
    this.content = content;
    this.available = available;
  }
  
  @computed get t0() {
    return this.content.DateFrom;
  }

  @computed get t1() {
    return this.content.DateTo;
  }

  @computed get bookable() {
    return this.available;
  }  
  
}

class TASSlot {
  @observable content = {};
  constructor(content) {
    this.content = content;
  }

  @computed get t0() {
    return this.content.TimeSlot;
  }

  @computed get t1() {
    return this.content.TimeSlotEnd;
  }

  @computed get bookable() {
    return this.content.IsBookable;
  }
}


export class AllotmentDetails {
  constructor(api, organization) {
    this.api = api;
    this.organization = organization;
    this.userCalChoice = '';
  }

  @observable contentUPDT = [];
  @observable contentTAS = [];
  
  async fetch({orgId, objId, timeUnitId, duration, startDate, endDate}) {
    [this.contentTAS, this.contentUPDT] = await Promise.all([
      this.api.getTimelineAllotmentWithSeasons({
        startDate, 
        endDate, 
        organizationId: orgId, 
        ids: objId, 
        durationTimeUnitId: timeUnitId, 
        durationTimeUnitQuantity: duration
      }),
      this.api.getUnavailablePickupAndDropoffTimes({
        startDate, 
        endDate, 
        organizationId: orgId, 
        objectId: objId, 
      }),
    ]);
  }

  cFetch = createSelector( 
    [p => p],
    (p) => this.fetch(p)
  )(
    ({orgId, objId, timeUnitId, duration}) => 
      `${orgId}@${objId}@${timeUnitId}@${duration}`,
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );


  @computed get updtSlots() {
    let result = [];
    for(let outer of this.contentUPDT) {
      for(let inner of outer.UnavailablePickupAndDropoffInterval) {
        result.push(new UPDTSlot(inner, outer.IsAvailable));
      }
    }
    return result;
  }

  @computed get updtDetails() {
    let result = [];
    for(let outer of this.contentUPDT) {
      for(let inner of outer.UnavailablePickupAndDropoffInterval) {
        result.push({
          start: moment(inner.DateFrom),
          end: moment(inner.DateTo),
        })
      }
    }
    return result;
  }

  @computed get updtDetailsDaily() {
    let result = [];
    for(let outer of this.contentUPDT) {
      result.push({
        date: moment(outer.Date),
        available: outer.IsAvailable,
      })
    }
    return result;    
  }

  @computed get unavailableDays() {
    let result = [];
    for(let outer of this.contentUPDT) {
      if(!outer.IsAvailable) {
        let end = moment(outer.Date).add({hours: 24});
        result.push({
          start: moment(outer.Date),
          end,
        });
      }
    }
    return result;
  }

  @computed get alreadyRentDetails() {
    let result = [];
    for(let outer of this.contentTAS) {
      if(!outer.IsBookable) {
        result.push({
          start: moment(outer.TimeSlot),
          end: moment(outer.TimeSlotEnd),
        })
      }
    }
    return result;
  }

  @computed get updtItems() {
    //return this.allotmentDetails.updtDayGranularity;

    // #10555/JAP
    console.log("showSchedulesInBW"+this.organization.showSchedulesInBW);
    if(!this.organization.showSchedulesInBW)
      return [];

    switch(this.calendarView) {
      case 'month':
        return this.updtDetailsDaily
          .filter(item => {
            return !item.available
          })
          .map(item => {
            let start = moment(item.date);
            let end = moment(item.date);
            return {
              ...item,
              start,
              end,
            }
          })        
          .map(item => {         
            return {
              ...item,
              allDay: true,
            }
          });
        break;
      case 'agendaWeekOneDay':
        return this.updtDetails;
        break;
    }
  }

  @computed get alreadyRentItems() {
    //return this.allotmentDetails.updtDayGranularity;
    switch(this.calendarView) {
      case 'month':
        let ard = this.alreadyRentDetails
          .filter(item => {
            return item.end.diff(item.start, 'seconds') >= 24*60*60;
          });
        let resultingItems = [];
        for(let item of ard) {
          let atoStart = moment(item.start).startOf('day');
          while(atoStart.isSameOrBefore(moment(item.end).add({days: 1}))) {
            if(
              item.start.isSameOrBefore(atoStart) && atoStart.isSameOrBefore(item.end) &&
              item.start.isSameOrBefore(moment(atoStart).add({days: 1})) && moment(atoStart).add({days: 1}).isSameOrBefore(item.end)
            ) {
              resultingItems.push({
                start: moment(atoStart),
                end: moment(atoStart),
              });
            }
            atoStart.add({days: 1});
          }
        }
        
        console.log(resultingItems)
        return resultingItems       
          .map(item => {
            return {
              ...item,
              allDay: true,
            }
          });
        break;
      case 'agendaWeekOneDay':
        return this.alreadyRentDetails;
        break;
    }
  }  

  
  @observable calendarView = 'month';
  @observable calendarDefaultDate;

  @action.bound setCalendarViewType(viewType) {
    if(this.userCalChoice) return;
    this.calendarView = viewType;
  }

  @action.bound setCalendarViewTypeByTUId(tuId) {
    switch(tuId) {
      case TIME_UNIT_ID.WEEK:
      case TIME_UNIT_ID.DAY:
      case TIME_UNIT_ID.NIGHT:
        this.setCalendarViewType('month');
        return;
      case TIME_UNIT_ID.HOUR:
      case TIME_UNIT_ID.QUARTER_HOUR:
        this.setCalendarViewType('agendaWeekOneDay');
        return;
    }
  }    

  @action.bound setCalendarViewTypeByTimespan(startDate, endDate) {
    if(moment(endDate).diff(moment(startDate), 'days') <= 3) {
      this.setCalendarViewType('agendaWeekOneDay');
    } else {
      this.setCalendarViewType('month');
    }
  }

  @action.bound setCalendarDefaultDate(defaultDate) {
    this.calendarDefaultDate = defaultDate;
  }

  goToday = () => {
    let date = moment();
    this.calendarDefaultDate = date;
    this.loadDataForView();
  }

  goSelection = (selection) => {
    this.calendarDefaultDate = selection.start;
    this.loadDataForView();
  }

  goPrev = () => {
    let date = moment(this.calendarDefaultDate);
    switch(this.calendarView) {
      case 'month':    
        //date.subtract({months: 1});
        date.subtract({days: 7});
        break;
      case 'agendaWeekOneDay':
        date.subtract({days: 1});
        break;
    }
    this.calendarDefaultDate = date;
    this.loadDataForView();
  }

  goNext = () => {
    let date = moment(this.calendarDefaultDate);
    switch(this.calendarView) {
      case 'month':    
        //date.add({months: 1});
        date.add({days: 7});
        break;
      case 'agendaWeekOneDay':
        date.add({days: 1});
        break;
    }
    this.calendarDefaultDate = date;
    this.loadDataForView();
  }

  goPrevFast = () => {
    let date = moment(this.calendarDefaultDate);
    switch(this.calendarView) {
      case 'month':    
        date.subtract({months: 1});
        break;
      case 'agendaWeekOneDay':
        date.subtract({days: 7});
        break;
    }
    this.calendarDefaultDate = date;
    this.loadDataForView();
  }

  goNextFast = () => {
    let date = moment(this.calendarDefaultDate);
    switch(this.calendarView) {
      case 'month':    
        date.add({months: 1});
        break;
      case 'agendaWeekOneDay':
        date.add({days: 7});
        break;
    }
    this.calendarDefaultDate = date;
    this.loadDataForView();
  }  

  changeViewType = () => {
    switch(this.calendarView) {
      case 'month':
        this.calendarView = 'agendaWeekOneDay';
        break;
      case 'agendaWeekOneDay':
        this.calendarView = 'month';
        break;
    }
    this.userCalChoice = this.calendarView;
    this.loadDataForView();
  }
  

  getLoadingStartDate() {
    switch(this.calendarView) {
      case 'month':
        return moment(this.calendarDefaultDate).subtract({days: 120});
        break;
      case 'agendaWeekOneDay':
        return moment(this.calendarDefaultDate).subtract({days: 28});
        break;
    }    
  }

  getLoadingEndDate() {
    switch(this.calendarView) {
      case 'month':
        return moment(this.calendarDefaultDate).add({days: 120});
        break;
      case 'agendaWeekOneDay':
        return moment(this.calendarDefaultDate).add({days: 28});
        break;
    } 
  }  

  @action.bound async fetchAllotmentDetails() {
    const {orgId, objId} = this;
    this.loadedForStart = moment(this.getLoadingStartDate());
    this.loadedForEnd = moment(this.getLoadingEndDate());
    await this.fetch({
      orgId, 
      objId, 
      startDate: this.loadedForStart.toISOString(),
      endDate: this.loadedForEnd.toISOString(),
    })
  }  

  @action.bound async loadDataForView() {
    const view = this.calendarView;
    switch(view) {
      case 'month':
        if(!this.loadedForStart || (
          this.calendarDefaultDate.diff(this.loadedForStart, 'days') < 50 ||
          this.loadedForEnd.diff(this.calendarDefaultDate, 'days') < 50
        )) {
          await this.fetchAllotmentDetails();     
        }
        break;
      case 'agendaWeekOneDay':
        if(!this.loadedForStart || (
          this.calendarDefaultDate.diff(this.loadedForStart, 'days') < 14 ||
          this.loadedForEnd.diff(this.calendarDefaultDate, 'days') < 14
        )) {
          await this.fetchAllotmentDetails();       
        }
        break;        
    }    
  }
}


// WEBPACK FOOTER //
// ./src/model/AllotmentDetails.js